/* eslint-disable sonarjs/cognitive-complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import utility from '@tcp/core/src/components/features/CnC/Checkout/util/utility';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { CHECKOUT_ROUTES } from '@tcp/core/src/components/features/CnC/Checkout/Checkout.constants';
import { isMobileWeb } from '@tcp/core/src/utils';
import LoginEmailSection from '../../LoginEmailSection';
import LoginPasswordSection from '../../LoginPasswordSection';
import LoginHelloScreen from '../../LoginHelloScreen';
import LoginHelloScreenV2 from '../../LoginHelloScreen/views/LoginHelloScreenV2.view';
import styles from '../styles/LoginSectionV2.styles';
import LoginOTPSection from '../../LoginOTPSection';
import pushEventToAdobeAnalytics from '../../../../../../../adobeAnalytics/adobe.utils';
import { getLabelFromCopyOrFromTranslation } from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_LOGIN_LABELS,
  GlobalLoginLabels,
  lblLoginBackToBag,
  lblLoginCheckoutAsGuest,
} from '../../../../../../../utils/labels/globalLogin.labels';
import CreateAccountOtpForm from '../../../molecules/CreateAccountOtpForm/views/CreateAccountOtpForm.view';

class LoginSectionV2 extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      newCodeSent: false,
    };
  }

  componentDidMount() {
    const { trackAnalyticsPageView } = this.props;
    trackAnalyticsPageView({});
  }
  /* istanbul ignore next */

  onClickBackToBag = (e, fromEmail) => {
    if (!fromEmail) {
      e.preventDefault();
    }
    setTimeout(() => {
      const {
        trackAnalyticsClick,
        setShowBriteErrorMessage,
        setBriteErrorMessageData,
        isBriteVerifyForLoginEnabled,
      } = this.props;
      if (isBriteVerifyForLoginEnabled) {
        setShowBriteErrorMessage(false);
        setBriteErrorMessageData(false);
      }

      const backToBagLabel = getLabelFromCopyOrFromTranslation(
        `${GLOBAL_LOGIN_LABELS}.${lblLoginBackToBag}`,
        GlobalLoginLabels
      );
      trackAnalyticsClick({
        metric33: '1',
        eVar150: backToBagLabel,
        customEvents: ['event33'],
      });
      utility.routeToPage(CHECKOUT_ROUTES.bagPage);
    }, 0);
  };

  /* istanbul ignore next */
  routeToCheckout = (e) => {
    const { routeForBagCheckout, trackAnalyticsClick } = this.props;
    /* istanbul ignore else */
    const checkoutAsGuestLabel = getLabelFromCopyOrFromTranslation(
      `${GLOBAL_LOGIN_LABELS}.${lblLoginCheckoutAsGuest}`,
      GlobalLoginLabels
    );
    trackAnalyticsClick({
      metric33: '1',
      metric36: '1',
      eVar150: checkoutAsGuestLabel,
      customEvents: ['event33', 'event36'],
    });
    if (e) {
      e.preventDefault();
    }
    routeForBagCheckout();
  };

  onEmailButtonClick = (payload) => {
    const { onEmailSubmit, trackAnalyticsClick } = this.props;
    trackAnalyticsClick({ metric34: '1', customEvents: ['event34'] });
    pushEventToAdobeAnalytics('checkout_email');
    onEmailSubmit(payload);
  };

  /* istanbul ignore next */
  onCheckoutAsGuestButtonClick = () => {
    const { trackAnalyticsClick } = this.props;
    trackAnalyticsClick({ metric36: '1', customEvents: ['event36'] });
  };

  getEmailSectionContainer = () => {
    const {
      existingUserResponse,
      emailAddressFromSS,
      isExistingUserFromSS,
      isRememberedUser,
      isShowOTPInputScreen,
      isLoginWithOTPEnabled,
      isBonusPointsEventMessagingEnabled,
      bonusPointEventMessageValue,
    } = this.props;
    const { emailAddress } = existingUserResponse || {};
    const emailSectionProps = { ...this.props, onSubmit: this.onEmailButtonClick };
    const checkoutAsGuestProps = {
      ...this.props,
      checkoutAsGuestTrackAnalytics: this.onCheckoutAsGuestButtonClick,
    };
    return (
      <>
        {!isShowOTPInputScreen && (
          <>
            {(isExistingUserFromSS && emailAddress) || isRememberedUser ? (
              <>
                <LoginPasswordSection
                  {...checkoutAsGuestProps}
                  backToBag={this.onClickBackToBag}
                  handleContinueAsGuest={this.routeToCheckout}
                  isV2Flow
                />
              </>
            ) : (
              <>
                {!isExistingUserFromSS && (emailAddressFromSS || emailAddress) ? (
                  <>
                    {!isLoginWithOTPEnabled && (
                      <LoginHelloScreen
                        {...checkoutAsGuestProps}
                        backToBag={this.onClickBackToBag}
                        handleContinueAsGuest={this.routeToCheckout}
                        isV2Flow
                      />
                    )}

                    {isLoginWithOTPEnabled && (
                      <LoginHelloScreenV2
                        {...checkoutAsGuestProps}
                        backToBag={this.onClickBackToBag}
                        handleContinueAsGuest={this.routeToCheckout}
                        isV2Flow
                        isBonusPointsEventMessagingEnabled={isBonusPointsEventMessagingEnabled}
                        bonusPointEventMessageValue={bonusPointEventMessageValue}
                        emailAddressFromSS={emailAddressFromSS || emailAddress}
                      />
                    )}
                  </>
                ) : (
                  <LoginEmailSection
                    {...emailSectionProps}
                    backToBag={this.onClickBackToBag}
                    isV2Flow={true}
                  />
                )}
              </>
            )}
          </>
        )}
      </>
    );
  };

  generateOTP = (payload) => {
    const { onGenerateOTP, otpMessageThreshold, loginErrorMessage } = this.props;
    onGenerateOTP({ isResend: true, ...payload });
    if (!loginErrorMessage && loginErrorMessage === '') {
      this.setState({ newCodeSent: true });
    }
    const timer = setTimeout(() => {
      this.setState({ newCodeSent: false });
      clearTimeout(timer);
    }, otpMessageThreshold);
  };

  onOTPVerify = (values) => {
    const { onSubmit, existingUserResponse } = this.props;
    const { rememberMe, emailAddress } = existingUserResponse;

    const payload = { ...values, emailAddress, rememberMe };
    onSubmit(payload);
  };

  // eslint-disable-next-line complexity
  getEmailSection = () => {
    const { newCodeSent } = this.state;

    const otpSectionProps = {
      ...this.props,
      newCodeSent,
      onSubmit: this.onOTPVerify,
      generateOTP: this.generateOTP,
    };

    const {
      existingUserResponse,
      isOTpScreenEnabled,
      loginErrorMessage,
      resetLoginState,
      routeForBagCheckout,
      otpToken,
      setIsFromCreateAccount,
      isLoading,
      setLoader,
      saveExistingUserResponse,
      sessionStorageUserInfo,
      isUnverifiedAccount,
      showRecaptcha,
    } = this.props;
    const { emailAddress, vstatus } = existingUserResponse || {};
    const {
      vstatus: verificationStatus,
      otpLimit,
      token,
      locked,
      lockTime,
      isCreateAccountOtpScreen,
    } = sessionStorageUserInfo || {};

    const showCreateAccOtpScreen =
      (vstatus !== undefined && !vstatus) ||
      (verificationStatus !== undefined && !verificationStatus) ||
      isUnverifiedAccount ||
      (vstatus !== undefined && !vstatus && (otpLimit || locked)) ||
      (verificationStatus !== undefined && !verificationStatus && (otpLimit || locked));
    return (
      <>
        {(showCreateAccOtpScreen && isOTpScreenEnabled && emailAddress) ||
        (isCreateAccountOtpScreen && emailAddress) ? (
          <CreateAccountOtpForm
            emailAddress={existingUserResponse?.emailAddress || emailAddress}
            isFromCheckout={true}
            routeForBagCheckout={routeForBagCheckout}
            saveExistingUserResponse={saveExistingUserResponse}
            loginErrorMessage={loginErrorMessage}
            resetLoginState={resetLoginState}
            otpToken={otpToken || token}
            setIsFromCreateAccount={setIsFromCreateAccount}
            isLoginLoading={isLoading}
            setLoader={setLoader}
            otpLimit={otpLimit}
            locked={locked}
            isFromLoginCheckoutFlow
            showRecaptcha={showRecaptcha}
            lockTime={lockTime}
            {...otpSectionProps}
          />
        ) : (
          this.getEmailSectionContainer()
        )}
      </>
    );
  };

  render() {
    const {
      existingUserResponse,
      className,
      isShowOTPInputScreen,
      isOTpScreenEnabled,
      sessionStorageUserInfo,
      isNewLoginScreen,
      isUnverifiedAccount,
    } = this.props;
    const { emailAddress, vstatus } = existingUserResponse || {};
    const { vstatus: verificationStatus } = sessionStorageUserInfo || {};

    const showCreateAccOtpScreen =
      (vstatus !== undefined && !vstatus) ||
      (verificationStatus !== undefined && !verificationStatus) ||
      isUnverifiedAccount;

    const getDynamicClassName = () => {
      if (showCreateAccOtpScreen && isOTpScreenEnabled && isMobileWeb()) {
        return `elem-pt-LRG_1`;
      }
      if (isNewLoginScreen && !showCreateAccOtpScreen) {
        return `elem-pt-XXXL`;
      }
      return '';
    };

    return (
      <div className={`${className} ${getDynamicClassName()}`}>
        <Row fullBleed>
          <Col
            className={
              showCreateAccOtpScreen && isOTpScreenEnabled && emailAddress
                ? 'login-checkout-section-container'
                : ''
            }
            ignoreGutter={{ small: true }}
            colSize={{ small: 6, medium: 4, large: 4 }}
            offsetLeft={{
              small: 0,
              medium: 2,
              large: 4,
            }}
            offsetRight={{
              small: 0,
              medium: 2,
              large: 4,
            }}
          >
            {isShowOTPInputScreen && (
              <div className="elem-ml-MED elem-mr-MED">
                <LoginOTPSection
                  {...this.props}
                  emailAddress={emailAddress}
                  backToBag={this.onClickBackToBag}
                  isV2Flow
                />
              </div>
            )}
            {this.getEmailSection()}
          </Col>
        </Row>
      </div>
    );
  }
}

LoginSectionV2.propTypes = {
  userSavedEmail: PropTypes.string,
  existingUserResponse: PropTypes.shape({}),
  onEmailSubmit: PropTypes.func,
  emailAddressFromSS: PropTypes.string,
  isExistingUserFromSS: PropTypes.string,
  routeForBagCheckout: PropTypes.func,
  className: PropTypes.string,
  trackAnalyticsPageView: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  trackAnalyticsClick: PropTypes.func,
  isLoginWithOTPEnabled: PropTypes.bool,
  otpMessageThreshold: PropTypes.number,
};

LoginSectionV2.defaultProps = {
  userSavedEmail: '',
  existingUserResponse: {},
  onEmailSubmit: () => {},
  emailAddressFromSS: '',
  isExistingUserFromSS: false,
  className: '',
  routeForBagCheckout: () => {},
  trackAnalyticsClick: () => {},
  isLoginWithOTPEnabled: false,
  otpMessageThreshold: 5000,
};

export default withStyles(LoginSectionV2, styles);
export { LoginSectionV2 as LoginSectionV2Vanilla };
